import React from 'react';
import { Flex, Spacer, Box, Divider } from '@chakra-ui/react';
import GuestDropdown from '@view/components/Popovers/GuestDropdown';

const DemoGuestDropdown = () => {
  return (
    <Box>
      <h2>Guest Dropdown</h2>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>Max occupancy - 6</p>
        <Spacer />
        <Box>
          <GuestDropdown adults={0} kids={0} maxOccupancy={6} />
        </Box>
      </Flex>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>Max occupancy - 10</p>
        <Spacer />
        <Box>
          <GuestDropdown adults={0} kids={0} maxOccupancy={10} />
        </Box>
      </Flex>
    </Box>
  );
};

export default DemoGuestDropdown;
